import { PageList } from "../../components/pageList";
import React from "react";

import ActionCellRender from "../../components/actionCellRender";
import {
  IconPencil,
  IconTrash,
  IconSettings,
  IconDownload,
  IconSearch,
  IconX,
  IconCheck,
} from "@tabler/icons";
import { showNotification } from "@mantine/notifications";
import {
  ENUM_FORM_DISPLAY,
  ENUM_FORM_LAYOUT_CONTAINER,
} from "../../components/pageList";
import { useCellRender } from "../../hooks/useCellRender";
import FileList from "../../components/fileList";
import ActivityLog from "../../components/activityLog.js";
import RemoteSelect2 from "../../components/remoteSelect2";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { useServerApi } from "../../hooks/userServerApi";
import { useAuthUser } from "react-auth-kit";
import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { useLocalStorage, useDebouncedValue } from "@mantine/hooks";
import { PaginationBar } from "../../components/dataTable";

import {
  Select,
  Checkbox,
  TextInput,
  Input,
  Badge,
  Text,
  Switch,
  Textarea,
  NumberInput,
  Group,
  Button,
  UnstyledButton,
  ScrollArea,
  Table,
  Box,
  Grid,
  SegmentedControl,
} from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import moment from "moment";
import { FormSectionCard, Page } from "../../layout/page";
import { OrderFilter } from "../../components/orderFilter";
import QuotationDescription from "../../components/quotationDescription";
import QuotationDescriptionBox from "../../components/quotationDescriptionBox";
import QuotationTerms from "../../components/quotationTerm";
import QuotationChargeItems from "../../components/quotationChargeItems.js";
import QuotationCostItems from "../../components/debiteNoteCostItems.js";
import DebitNoteActionList from "../../components/debitNoteActionList";
import QuotationChargeSummary from "../../components/quotationChargeSummary";
import QuotationActionList from "../../components/quotationActionList";
import DummyWidget from "../../components/dummyWidget";
import OrderInsuredList from "../../components/orderInsuredList";
import OrderAddressSelect from "../../components/orderAddressSelect";
import DebitNotePageStats from "../../components/debitNotePageStats";
import OrderConsultantList from "../../components/orderConsultantList";
import OrderApplicantDetail from "../../components/orderApplicantDetail";

import QuotationSummary from "../../components/quotationSummary";
import remoteSelect2 from "../../components/remoteSelect2";
import OrderClientSelect from "../../components/orderClientSelect";
import ProductSelection from "../../components/productSelection";
import ConsultantList from "../../components/consultantList";
import FormConfirmation from "../../components/formConfirmation";
import UniqueTextInput from "../../components/uniqueTextInput";
import QuoRequestFileCheckList from "../../components/quoRequestFileCheckList";
import QuoFileList from "../../components/quofileList";

import RenewalPageStats from "../../components/renewalPageStats";
import QuotationDescriptions from "../../components/quotationDescription";
import RenewalPreviousRecord from "../../components/renewalPreviousRecord";
import DebitNoteRelatedDebitNotesSection from "../../components/debitNoteRelatedDebitNotesSection";

import RichTextEditor from "../../components/richTextEditor";
import RenewalActionList from "../../components/renewalActionList";
import { DATA_RENEWAL_REJECTION_REASON } from "../../data/options";

import DebitNoteChargeItems from "../../components/debiteNoteChargeItems.js";
import DebitNoteCostItems from "../../components/debiteNoteCostItems.js";
import ReactJson from "react-json-view";
import { useNavigate, useLocation } from "react-router-dom";
import { useTabNavigate } from "../../hooks/useTabNavigate";
import { useTabActionsOptional } from "../../context/tabContext";
import { getEntityTabLabel } from "../../utils/tabNavigation";
import DNParticularList from "../../components/dnParticularList";
import { openFileUrl } from "../../utils/openReport";

const apiEntity = "renewal";
const RENEWAL_STATUS = ["DFT", "PENDING", "WAIT", "CONFIRM", "TERMINATE"];
const initialValues = {
  consultants: [],

  date: moment().toISOString(),
  descriptions: [{ title: "", detail: "" }],
  terms: [{ title: "", detail: "" }],
  period: {
    start: null,
    end: null,
  },
  chargeItems: [
    { item: "Premium", currency: "HKD", qty: 1, unitPrice: 0, price: 0 },
    { item: "IA Levy", currency: "HKD", qty: 1, unitPrice: 0, price: 0 },
  ],
  costItems: [
    { item: "Net Premium", currency: "HKD", qty: 1, unitPrice: 0, price: 0 },
    { item: "IA Levy", currency: "HKD", qty: 1, unitPrice: 0, price: 0 },
  ],
  discountAmount: 0,
  total: 0,
  logs: [],
  signedBy: { _id: "64198bbc7378cf27c26f4998" },
  status: "DFT",
};

export const addFormSchema = {
  title: "Create Quotation",
  name: "quotationSchema",
  isMainForm: true,

  description: "Please follow the step to create a New Quotation",
  display: {
    mode: ENUM_FORM_DISPLAY.MODAL,
    size: "xl", //xs, sm, xl  ....100%
    position: "right",
  },
  apiEntity,
  initialValues,
  layout: {
    // containers: [
    //   // {
    //   //   key: "t1",
    //   //   parent: null,
    //   //   type: ENUM_FORM_LAYOUT_CONTAINER.WIZARD,
    //   //   props: {
    //   //     variant: "default", //default | pills | outline
    //   //     defaultValue: "Quotation Code",
    //   //     orientation: "vertical",
    //   //     style: { minHeight: "400px" },
    //   //   },
    //   //   steps: [
    //   //     { key: "t1-0", label: "Quotation Code", icon: IconSettings },
    //   //     { key: "t1-1", label: "Client", icon: IconSettings },
    //   //     { key: "t1-2", label: "Consultant", icon: IconSettings },
    //   //     { key: "t1-3", label: "Product", icon: IconSettings },
    //   //     { key: "t1-4", label: "Period", icon: IconSettings },
    //   //     { key: "t1-5", label: "Confirmation ", icon: IconSettings },
    //   //   ],
    //   // },
    // ],
    fields: [
      {
        name: "consultants",
        component: RemoteSelect2,
        props: {
          apiEntity: "user",
          required: true,
          label: "Consultants",
          placeholder: "Please select consultant(s)",
          valueField: "_id",
          labelField: "name",
          labelRender: (data) =>
            `[${data.staffId ?? " -- "}] ${data.name} ${
              data.aliasName ? `,${data.aliasName}` : ""
            }  ${data.cname} `,
          multiple: true,
          preQuery: {
            $and: [{ isConsultant: true }, { status: "ACTIVE" }],
          },
          pageSize: 2000,
          searchFields: [
            "aliasName",
            "name",
            "staffId",
            "cname",
            "email",
            "phone",
          ],
          sort: {
            by: "name",
            order: "asc",
          },
        },
      },
      {
        name: "productType",
        component: RemoteSelect2,
        props: {
          apiEntity: "productType",
          required: true,
          label: "Product Type",
          placeholder: "Select Product Type",
          valueField: "_id",
          labelField: "name",
          labelRender: (data) => `${data.name} ${data.cname}`,

          multiple: false,
          pageSize: 500,
          mt: 0,
          searchFields: ["code", "name", "cname"],
          sort: {
            by: "name",
            order: "asc",
          },
        },
      },
      {
        name: "provider",
        component: RemoteSelect2,
        props: {
          apiEntity: "provider",
          required: true,
          label: "Insurance Company",
          placeholder: "Select Provider",
          valueField: "_id",
          labelField: "name",
          labelRender: (data) =>
            `[${data.shortName ?? data.code}] ${data.name} ${data.cname ?? ""}`,
          multiple: false,
          pageSize: 500,
          searchFields: ["code", "name", "cname"],
          sort: {
            by: "name",
            order: "asc",
          },
        },
      },

      {
        name: "insuredName",
        component: TextInput,
        props: {
          required: true,
          label: "Insured Name",
        },
      },
      {
        name: "address",
        component: TextInput,
        props: {
          label: "Address",
        },
      },

      {
        name: "period.start",
        component: DatePicker,
        type: "datePicker",
        props: {
          label: "Period Start",
          zIndex: 1000,
          placeholder: "Pick Date",
          allowFreeInput: true,
        },
      },
      {
        name: "period.end",
        component: DatePicker,
        type: "datePicker",
        props: {
          label: "Period End",
          zIndex: 1000,
          placeholder: "Pick Date",
          allowFreeInput: true,
        },
      },
    ],
  },
};

export const adjustFormSchema = {
  name: "quotation",
  title: "Adjust Quotation",
  description: "Please follow the step to edit the quotation",
  display: {
    mode: ENUM_FORM_DISPLAY.MODAL,
  },
  apiEntity,
  showSaveBar: false,

  initialValues,

  layout: {
    containers: [
      {
        key: "t1",
        parent: null,
        type: ENUM_FORM_LAYOUT_CONTAINER.WIZARD,

        props: {
          variant: "default", //default | pills | outline
          defaultValue: "DN Code",
          orientation: "vertical",
          style: { minHeight: "400px" },
        },
        steps: [
          { key: "t1-0", label: "Quo Code", icon: IconSettings },
          { key: "t1-3", label: "Product", icon: IconSettings },
          { key: "t1-4", label: "Policy", icon: IconSettings },
          { key: "t1-5", label: "Confirmation ", icon: IconSettings },
        ],
      },
    ],
    fields: [
      {
        name: "code",
        component: UniqueTextInput,
        parent: "t1-0",
        props: {
          required: true,
          uniqueEntity: "quotation",
          errorMessage: "Quotation is already exist.",
          label: "Code (Auto if empty)",
          placeholder: "QUO23100011",
          mt: 0,
        },
      },

      {
        name: "product",
        component: ProductSelection,
        parent: "t1-3",
        props: {
          title: "Product",
          showProductSnapShot: false,
        },
      },

      {
        name: "policyNumber",
        component: TextInput,
        parent: "t1-4",
        props: {
          label: "Policy Number",
          showProductSnapShot: false,
        },
      },

      {
        name: "period.start",
        component: DatePicker,
        parent: "t1-4",
        type: "datePicker",

        props: {
          label: "Period From",
          zIndex: 1000,
          placeholder: "Pick Date",
          allowFreeInput: true,
        },
      },

      {
        name: "period.end",
        component: DatePicker,
        type: "datePicker",
        parent: "t1-4",
        props: {
          label: "Period To",
          zIndex: 1000,
          placeholder: "Pick Date",
          allowFreeInput: true,
        },
      },

      {
        name: "date",
        component: DatePicker,
        type: "datePicker",
        parent: "t1-4",
        props: {
          label: "Debit Note Date",
          zIndex: 1000,
          placeholder: "Pick Date",
          allowFreeInput: true,
        },
      },
      {
        name: "confirm",
        component: FormConfirmation,
        parent: "t1-5",
        props: {
          successText: [
            "Please confirm only if the provided information is correct.",
          ],
        },
      },
    ],
  },
};

const Renewal = ({ role }) => {
  const [cellRender] = useCellRender();
  const { t } = useTranslation();
  const [preQuery, setPreQuery] = useState();
  const navigate = useNavigate();
  const location = useLocation();
  const tabNav = useTabNavigate();
  const tabActions = useTabActionsOptional();
  /** Management GI renewal (/m/gi/renewal): all consultants; route may omit role prop */
  const isManagementGiRenewal =
    role === "MANAGEMENT" ||
    (location.pathname && location.pathname.includes("/m/gi/renewal"));
  const useManagementGiPaths =
    location.pathname && location.pathname.includes("/m/gi/");

  const searchParams = new URLSearchParams(location.search);
  const linkRenewalId = searchParams.get("id");
  const linkRenewalMode = searchParams.get("mode");
  const openRenewalFromLink =
    Boolean(linkRenewalId) && linkRenewalMode === "edit";
  const showRenewalPageList =
    (role !== "CONSULTANT" && !isManagementGiRenewal && preQuery) ||
    (openRenewalFromLink && preQuery !== undefined);

  const [api] = useServerApi();
  const auth = useAuthUser();

  // GI Pending Renewals state (for CONSULTANT role)
  const [pendingRenewals, setPendingRenewals] = useState([]);
  const [downloadingRenewals, setDownloadingRenewals] = useState(false);
  const [activeTab, setActiveTab] = useState("all");
  // Pagination state (CONSULTANT role)
  const [pendingListPage, setPendingListPage] = useState(1);
  const [pendingListPageSize, setPendingListPageSize] = useLocalStorage({
    key: "mbid-page-size",
    defaultValue: 50,
    /** Read storage in useState init so first fetch matches the selector (default true defers read to useEffect). */
    getInitialValueInEffect: false,
  });
  const [pendingListTotal, setPendingListTotal] = useState(0);
  const [pendingListTotalPage, setPendingListTotalPage] = useState(1);

  // GI Pending Renewals state (for MANAGEMENT role)
  const [managementPendingRenewals, setManagementPendingRenewals] = useState(
    [],
  );
  const [managementDownloadingRenewals, setManagementDownloadingRenewals] =
    useState(false);
  const [managementActiveTab, setManagementActiveTab] = useState("all");
  // Pagination state (MANAGEMENT role)
  const [managementPendingListPage, setManagementPendingListPage] = useState(1);
  const [managementPendingListTotal, setManagementPendingListTotal] =
    useState(0);
  const [managementPendingListTotalPage, setManagementPendingListTotalPage] =
    useState(1);

  /** Shared search for consultant + management pending tables (filters DN `searchText` on server). */
  const [pendingListSearchInput, setPendingListSearchInput] = useState("");
  const [debouncedPendingSearch] = useDebouncedValue(
    pendingListSearchInput,
    300,
  );
  const pendingSearchForApi = debouncedPendingSearch.trim();
  const lastConsultantSearchForPageRef = useRef(pendingSearchForApi);
  const lastManagementSearchForPageRef = useRef(pendingSearchForApi);

  const consultantPendingTabStatsSeqRef = useRef(0);
  const managementPendingTabStatsSeqRef = useRef(0);
  const [consultantPendingTabStats, setConsultantPendingTabStats] =
    useState(null);
  const [managementPendingTabStats, setManagementPendingTabStats] =
    useState(null);

  /** While creating manual renewal, holds debit note id (string) for button loading state. */
  const [manualRenewalLoadingId, setManualRenewalLoadingId] = useState(null);

  // Date filter state (Month/Quarter/Year/Custom)
  const [dateFilter, setDateFilter] = useState({
    periodOption: "M", // M, Q, Y, C
    startDate: moment().startOf("month").format(),
    endDate: moment().endOf("month").format(),
  }); // notReceived, pending, confirmed, all

  const reviseSchemaForConsultant = async () => {
    //Consultant
    //Set Pre Query
    if (process.env.REACT_APP_DEBIT_NOTE_SEARCH_TEAM === "true") {
      try {
        const teamMembersIds = await api.User.getAllTeamMembers(auth().id);
        // If the environment variable is set to true, restrict search to user's team
        setPreQuery({
          consultants: { $in: [auth().id, ...(teamMembersIds || [])] },
        });
      } catch (error) {
        console.log("Error fetching team members:", error);
        // Fallback to just the current user
        setPreQuery({ consultants: auth().id });
      }
    } else {
      setPreQuery({ consultants: auth().id });
    }

    //Set Initial Values
    initialValues.consultants = [auth().id];
    initialValues.signedBy = auth().id;

    //Set Pre Query for Client field in add form
    const clientField = addFormSchema.layout.fields.find(
      (f) => f.name === "client",
    );
    if (clientField) {
      clientField.props.preQuery = { consultants: auth().id };
    }

    //Set Action List
    // const tabLayout = editFormSchema.layout.containers.find(
    //   (c) => c.key === "main-tab"
    // );
    // tabLayout.tab = tabLayout.tab.filter((t) => t.key != "tab-commission");

    // console.log("Tab Layout", tabLayout);
  };

  useEffect(() => {
    if (role === "CONSULTANT") {
      reviseSchemaForConsultant();
    } else {
      setPreQuery({});
    }
  }, [role]);

  // Helper functions for GI Pending Renewals
  // Fall back to app routes when userRole.entityLinks omit renewal/debitNote/client (consultant + /gi/renewal management).
  const getRenewalLink = () => {
    const { userRole } = auth();
    const fromRole = userRole?.entityLinks?.find(
      (l) => l.entity === "renewal",
    )?.link;
    if (fromRole) return fromRole;
    if (role === "CONSULTANT") return "/consultant/renewal";
    if (role === "MANAGEMENT") {
      return useManagementGiPaths ? "/m/gi/renewal" : "/gi/renewal";
    }
    return null;
  };

  const getDebitNoteLink = () => {
    const { userRole } = auth();
    const fromRole = userRole?.entityLinks?.find(
      (l) => l.entity === "debitNote",
    )?.link;
    if (fromRole) return fromRole;
    if (role === "CONSULTANT") return "/consultant/debitNote";
    if (role === "MANAGEMENT") {
      return useManagementGiPaths ? "/m/gi/debitNote" : "/gi/debitNote";
    }
    return null;
  };

  const getClientLink = () => {
    const { userRole } = auth();
    const fromRole = userRole?.entityLinks?.find(
      (l) => l.entity === "client",
    )?.link;
    if (fromRole) return fromRole;
    if (role === "CONSULTANT") return "/consultant/client";
    if (role === "MANAGEMENT") {
      return useManagementGiPaths ? "/m/gi/client" : "/gi/client";
    }
    return null;
  };

  /** Tab controller when enabled; window.open fallback keeps window.opener for LINK forms Close → window.close(). */
  const openLinkedDocument = ({ pathname, id, label, entityType }) => {
    if (!pathname || !id) return;
    const tabLabel = label || getEntityTabLabel(null, id, entityType);
    if (tabNav.enabled) {
      tabNav.openDetail({ pathname, id, mode: "edit", label: tabLabel });
      return;
    }
    window.open(`${pathname}?id=${id}&mode=edit`, "_blank");
  };

  const openClientEdit = (clientId, client) => {
    const base = getClientLink();
    if (!base || !clientId) return;
    openLinkedDocument({
      pathname: base,
      id: clientId,
      label: getEntityTabLabel(client, clientId, "client"),
      entityType: "client",
    });
  };

  const openDebitNoteEdit = (debitNoteId, code) => {
    const base = getDebitNoteLink();
    if (!base || !debitNoteId) return;
    openLinkedDocument({
      pathname: base,
      id: debitNoteId,
      label: code,
      entityType: "debitNote",
    });
  };

  const openRenewalEdit = (renewalId, code) => {
    const base = getRenewalLink();
    if (!base || !renewalId) return;
    openLinkedDocument({
      pathname: base,
      id: renewalId,
      label: code,
      entityType: "renewal",
    });
  };

  /** Post-confirm RN links to a new Debit Note (`renewal.debitNote` on server). */
  const getRenewalNewDebitNoteId = (dn) =>
    dn.renewal?.debitNote?._id ?? dn.renewal?.debitNote?.id;

  const handleManualRenewalFromDebitNote = async (dn) => {
    const id = dn._id ?? dn.id;
    if (!id || !dateFilter.startDate || !dateFilter.endDate) return;
    setManualRenewalLoadingId(String(id));
    try {
      const result = await api.Renewal.createManualFromDebitNote({
        debitNoteId: id,
        startDate: dateFilter.startDate,
        endDate: dateFilter.endDate,
      });
      if (result?.success) {
        const createdRenewal = result?.data?.renewal;
        const code = createdRenewal?.code;
        const patchRenewalOntoRow = (row) => {
          if (String(row._id ?? row.id) !== String(id)) return row;
          return {
            ...row,
            renewal: {
              ...(row.renewal || {}),
              _id: createdRenewal?._id,
              code: createdRenewal?.code,
              status: "PENDING",
              fromSystem: false,
              date: new Date().toISOString(),
            },
          };
        };
        setPendingRenewals((rows) => rows.map(patchRenewalOntoRow));
        setManagementPendingRenewals((rows) => rows.map(patchRenewalOntoRow));
        showNotification({
          title: t("Success"),
          message: code
            ? t("Renewal {{code}} created", { code })
            : t("Renewal created"),
          color: "teal",
          icon: <IconCheck size={18} />,
        });
        refreshPendingRenewalsViews();
      } else {
        const msg =
          result?.error?.msg ??
          result?.error?.message ??
          result?.message ??
          t("Request failed");
        showNotification({
          title: t("Error"),
          message: typeof msg === "string" ? msg : JSON.stringify(msg),
          color: "red",
        });
      }
    } catch (error) {
      console.log(error);
      showNotification({
        title: t("Error"),
        message: error?.message ?? String(error),
        color: "red",
      });
    } finally {
      setManualRenewalLoadingId(null);
    }
  };

  const fetchPendingRenewals = async () => {
    try {
      const searchChanged =
        lastConsultantSearchForPageRef.current !== pendingSearchForApi;
      lastConsultantSearchForPageRef.current = pendingSearchForApi;
      const page = searchChanged ? 1 : pendingListPage;
      if (searchChanged) {
        setPendingListPage(1);
      }
      const pRenewals = await api.Renewal.getPendingRenewalsByUser({
        startDate: dateFilter.startDate,
        endDate: dateFilter.endDate,
        page,
        limit: pendingListPageSize,
        tab: activeTab,
        search: pendingSearchForApi,
      });
      setPendingRenewals([...(pRenewals?.data?.debitNotes || [])]);
      // Update pagination metadata if present
      if (pRenewals?.data?.total !== undefined) {
        setPendingListTotal(pRenewals.data.total);
      }
      if (pRenewals?.data?.totalPage !== undefined) {
        setPendingListTotalPage(pRenewals.data.totalPage);
      }
    } catch (error) {
      console.log("Error fetching pending renewals:", error);
    }
  };

  const fetchManagementPendingRenewals = async () => {
    try {
      const searchChanged =
        lastManagementSearchForPageRef.current !== pendingSearchForApi;
      lastManagementSearchForPageRef.current = pendingSearchForApi;
      const page = searchChanged ? 1 : managementPendingListPage;
      if (searchChanged) {
        setManagementPendingListPage(1);
      }
      const pRenewals = await api.Renewal.getPendingRenewalsForManagement({
        startDate: dateFilter.startDate,
        endDate: dateFilter.endDate,
        page,
        limit: pendingListPageSize, // Share same page size storage
        tab: managementActiveTab,
        search: pendingSearchForApi,
      });
      setManagementPendingRenewals([...(pRenewals?.data?.debitNotes || [])]);
      // Update pagination metadata if present
      if (pRenewals?.data?.total !== undefined) {
        setManagementPendingListTotal(pRenewals.data.total);
      }
      if (pRenewals?.data?.totalPage !== undefined) {
        setManagementPendingListTotalPage(pRenewals.data.totalPage);
      }
    } catch (error) {
      console.log("Error fetching management pending renewals:", error);
    }
  };

  const refreshPendingRenewalsViews = useCallback(() => {
    queueMicrotask(async () => {
      if (role === "CONSULTANT") {
        await fetchPendingRenewals();
        try {
          const res = await api.Renewal.getPendingRenewalTabStatsByUser({
            startDate: dateFilter.startDate,
            endDate: dateFilter.endDate,
            search: pendingSearchForApi,
          });
          if (res?.success && res.data) {
            setConsultantPendingTabStats(res.data);
          }
        } catch (e) {
          console.log(e);
        }
      }
      if (isManagementGiRenewal) {
        await fetchManagementPendingRenewals();
        try {
          const res = await api.Renewal.getPendingRenewalTabStatsForManagement({
            startDate: dateFilter.startDate,
            endDate: dateFilter.endDate,
            search: pendingSearchForApi,
          });
          if (res?.success && res.data) {
            setManagementPendingTabStats(res.data);
          }
        } catch (e) {
          console.log(e);
        }
      }
    });
  }, [
    role,
    isManagementGiRenewal,
    dateFilter.startDate,
    dateFilter.endDate,
    pendingSearchForApi,
    activeTab,
    managementActiveTab,
    pendingListPage,
    managementPendingListPage,
    pendingListPageSize,
    api,
  ]);

  const downloadPendingRenewals = async () => {
    try {
      setDownloadingRenewals(true);
      const result = await api.Renewal.getPendingRenewalReportByUser({
        startDate: dateFilter.startDate,
        endDate: dateFilter.endDate,
      });
      if (result?.data?.url) {
        await openFileUrl(result.data.url);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setDownloadingRenewals(false);
    }
  };

  /** Same date range as the management table; full-firm export (mirrors getPendingRenewalReport / calendar admin report scope). */
  const downloadManagementPendingRenewalReport = async () => {
    try {
      setManagementDownloadingRenewals(true);
      const result = await api.Renewal.getPendingRenewalReport({
        startDate: dateFilter.startDate,
        endDate: dateFilter.endDate,
      });
      if (result?.data?.url) {
        await openFileUrl(result.data.url);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setManagementDownloadingRenewals(false);
    }
  };

  // Reset page when date filter or tab changes (CONSULTANT role); search reset is handled in fetch
  useEffect(() => {
    setPendingListPage(1);
  }, [dateFilter.startDate, dateFilter.endDate, activeTab]);

  // Reset page when date filter or tab changes (MANAGEMENT role); search reset is handled in fetch
  useEffect(() => {
    setManagementPendingListPage(1);
  }, [dateFilter.startDate, dateFilter.endDate, managementActiveTab]);

  // Fetch pending renewals when date, page, pageSize, or tab changes (CONSULTANT vs management /m/gi/renewal)
  useEffect(() => {
    if (openRenewalFromLink) return;
    if (role === "CONSULTANT") {
      fetchPendingRenewals();
    }
  }, [
    dateFilter.startDate,
    dateFilter.endDate,
    role,
    activeTab,
    pendingListPage,
    pendingListPageSize,
    debouncedPendingSearch,
    openRenewalFromLink,
  ]);

  useEffect(() => {
    if (openRenewalFromLink) return;
    if (isManagementGiRenewal) {
      fetchManagementPendingRenewals();
    }
  }, [
    dateFilter.startDate,
    dateFilter.endDate,
    isManagementGiRenewal,
    managementActiveTab,
    managementPendingListPage,
    pendingListPageSize,
    debouncedPendingSearch,
    openRenewalFromLink,
  ]);

  useEffect(() => {
    if (role !== "CONSULTANT" || openRenewalFromLink) return;
    let cancelled = false;
    const mySeq = ++consultantPendingTabStatsSeqRef.current;
    (async () => {
      try {
        const res = await api.Renewal.getPendingRenewalTabStatsByUser({
          startDate: dateFilter.startDate,
          endDate: dateFilter.endDate,
          search: pendingSearchForApi,
        });
        if (cancelled || mySeq !== consultantPendingTabStatsSeqRef.current)
          return;
        if (res?.success && res.data) {
          setConsultantPendingTabStats(res.data);
        }
      } catch (error) {
        console.log("Error fetching pending renewal tab stats:", error);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [
    role,
    openRenewalFromLink,
    dateFilter.startDate,
    dateFilter.endDate,
    debouncedPendingSearch,
  ]);

  useEffect(() => {
    if (!isManagementGiRenewal || openRenewalFromLink) return;
    let cancelled = false;
    const mySeq = ++managementPendingTabStatsSeqRef.current;
    (async () => {
      try {
        const res = await api.Renewal.getPendingRenewalTabStatsForManagement({
          startDate: dateFilter.startDate,
          endDate: dateFilter.endDate,
          search: pendingSearchForApi,
        });
        if (cancelled || mySeq !== managementPendingTabStatsSeqRef.current)
          return;
        if (res?.success && res.data) {
          setManagementPendingTabStats(res.data);
        }
      } catch (error) {
        console.log(
          "Error fetching management pending renewal tab stats:",
          error,
        );
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [
    isManagementGiRenewal,
    openRenewalFromLink,
    dateFilter.startDate,
    dateFilter.endDate,
    debouncedPendingSearch,
  ]);

  useEffect(() => {
    if (!tabActions?.enabled || openRenewalFromLink) return;
    const unsubs = [];
    const renewalLink = getRenewalLink();
    const debitNoteLink = getDebitNoteLink();
    if (renewalLink) {
      unsubs.push(
        tabActions.subscribeListRefresh(renewalLink, () => {
          refreshPendingRenewalsViews();
        }),
      );
    }
    if (debitNoteLink) {
      unsubs.push(
        tabActions.subscribeListRefresh(debitNoteLink, () => {
          refreshPendingRenewalsViews();
        }),
      );
    }
    return () => {
      unsubs.forEach((unsub) => unsub());
    };
  }, [
    tabActions,
    openRenewalFromLink,
    refreshPendingRenewalsViews,
    role,
    useManagementGiPaths,
  ]);

  const formatPendingTabStat = (stats, key) => {
    if (stats == null) return "\u2013";
    const v = stats[key];
    return v === undefined || v === null ? "\u2013" : String(v);
  };

  const consultantPendingTabSegmentedData = useMemo(
    () => [
      {
        label: `${t("All Cases")} (${formatPendingTabStat(
          consultantPendingTabStats,
          "all",
        )})`,
        value: "all",
      },
      {
        label: `${t("Not Received")} (${formatPendingTabStat(
          consultantPendingTabStats,
          "notReceived",
        )})`,
        value: "notReceived",
      },
      {
        label: `${t("Pending")} (${formatPendingTabStat(
          consultantPendingTabStats,
          "pending",
        )})`,
        value: "pending",
      },
      {
        label: `${t("Confirmed")} (${formatPendingTabStat(
          consultantPendingTabStats,
          "confirmed",
        )})`,
        value: "confirmed",
      },
    ],
    [consultantPendingTabStats, t],
  );

  const managementPendingTabSegmentedData = useMemo(
    () => [
      {
        label: `${t("All Cases")} (${formatPendingTabStat(
          managementPendingTabStats,
          "all",
        )})`,
        value: "all",
      },
      {
        label: `${t("Not Received")} (${formatPendingTabStat(
          managementPendingTabStats,
          "notReceived",
        )})`,
        value: "notReceived",
      },
      {
        label: `${t("Pending")} (${formatPendingTabStat(
          managementPendingTabStats,
          "pending",
        )})`,
        value: "pending",
      },
      {
        label: `${t("Confirmed")} (${formatPendingTabStat(
          managementPendingTabStats,
          "confirmed",
        )})`,
        value: "confirmed",
      },
    ],
    [managementPendingTabStats, t],
  );

  const tableSchema = {
    showActionColumn: true,
    preQuery,
    columns: [
      {
        field: "code",
        headerName: "Code",
        sortable: true,
        cellRender: (col, data) => cellRender.RenewalCode(data),
        filterable: true,
        filter: {
          apiEntity: "renewal",
          field: "status",
          label: "Status",
          width: 250,
          height: 300,
        },
      },
      {
        field: "receivedRenewal",
        headerName: "Received",
        sortable: true,
        cellRender: (col, data) => cellRender.RenewalReceived(data),
      },
      {
        field: "lastPolicyNumber",
        headerName: "Last DN",
        sortable: true,
        cellRender: (col, data) => <>{data.lastPolicyNumber}</>,
      },

      {
        field: "period.start",
        headerName: "Next",
        sortable: true,
        width: 120,
        cellRender: (col, data) => {
          const canOpenDebitNote =
            Boolean(data.debitNote?._id) && Boolean(getDebitNoteLink());
          return (
            <>
              {data.debitNote && (
                <>
                  <Badge
                    color="blue"
                    radius={0}
                    py={0}
                    size="xs"
                    onClick={
                      canOpenDebitNote
                        ? () =>
                            openDebitNoteEdit(
                              data.debitNote._id,
                              data.debitNote.code,
                            )
                        : undefined
                    }
                    style={{ cursor: canOpenDebitNote ? "pointer" : "default" }}
                  >
                    {data.debitNote?.code}
                  </Badge>
                </>
              )}
              <Text size="xs" color="dimmed">
                {data.period?.start &&
                  moment(data.period?.start).format("YYYY-MM-DD")}
              </Text>
            </>
          );
        },
      },
      {
        field: "product",
        headerName: "Product",
        sortable: true,
        // cellRender: (col, data) => cellRender.ProductInfo2(data.product),
        cellRender: (col, data) => {
          if (data.product)
            return cellRender.ProductInfo(
              data.product,
              "sm",
              data.particulars,
              {
                hideAvatar: true,
              },
            );
          if (data.productType || data.provider)
            return (
              <Text color="dimmed">
                {" "}
                {cellRender.ProductInfo2(data, "sm", { hideAvatar: true })}
              </Text>
            );
        },
      },

      {
        field: "insuredName",
        headerName: "Applicant",
        sortable: true,
        cellRender: (col, data) =>
          data.client ? cellRender.ClientInfo(data.client) : data.insuredName,
      },

      {
        field: "consultants",
        headerName: "Consultants",
        sortable: true,
        cellRender: (col, data) => cellRender.Users(data.consultants, true),
      },

      {
        field: "action",
        cellRender: ActionCellRender,
        isAction: true,
        actions: [
          {
            name: "edit",
            icon: IconPencil,
            props: {
              //   color:"red"
            },
          },
        ],
        actionMenu: [
          {
            name: "copy",
            label: "Copy",
            icon: IconTrash,
            props: {
              // color: "red",
            },
          },
          {
            name: "delete",
            label: "Delete data",
            icon: IconTrash,
            props: {
              color: "red",
            },
          },
        ],
      },
    ],
    searchableFields: [
      "code",
      "status",
      "insuredName",
      "client.name",
      "searchText",
      "policyNumber",
    ],
    select: [
      "code receivedRenewal debitNote particulars productType provider product policyNumber client consultants status payment paymentStatus clientPayable createdAt signedAt discountAmount commissionRate costTotal lastPolicyNumber fromSystem period.start",
    ],
    advanceFilters: [
      {
        field: "status",
        label: "Status",
        type: "select",
        options: RENEWAL_STATUS,
      },
      {
        field: "period.start",
        label: "Next",
        type: "dateRange",
        props: {
          label: "Next",
          placeholder: "Select Next",
        },
      },
      {
        field: "provider",
        label: "Insurer",
        type: "RemoteSelect",
        props: {
          apiEntity: "provider",
          valueField: "_id",
          labelField: "name",
          labelRender: (data) => `[${data.code}] ${data.name}`,
          searchFields: ["name", "code"],
        },
      },
      {
        field: "productType",
        label: "Class",
        type: "RemoteSelect",
        props: {
          apiEntity: "productType",
          valueField: "_id",
          labelField: "name",
          labelRender: (data) => `[${data.code}] ${data.name}`,
          searchFields: ["name", "code"],
        },
      },

      {
        field: "client",
        type: "RemoteSelect",
        label: "Client",
        props: {
          apiEntity: "client",
          valueField: "_id",
          select: "name code shortName cname",
          // labelField: "name",
          labelRender: (data) =>
            `[ ${data.code ?? data.code ?? " -- "} ] ${data.name} ${
              data.cname ? `(${data.cname})` : ""
            } `,
          searchFields: ["name", "id", "cname", "code"],
          clearable: true,
          allowClear: true,
          sort: {
            by: "code",
            order: "asc",
          },
        },
      },
      {
        field: "consultants",
        type: "RemoteSelect",
        label: "Consultants",
        props: {
          apiEntity: "user",
          valueField: "_id",
          select: "name code shortName cname staffId aliasName",
          labelField: "name",
          labelRender: (data) => {
            // if (!data) return null;
            try {
              let text = "";
              if (data?.staffId) text += `[${data?.staffId}] `;
              if (data?.name) text += `${data?.name}`;
              if (data?.aliasName) text += ` (${data?.aliasName})`;
              return text;
            } catch (e) {
              console.error(e);
              return "";
            }
          },
          searchFields: [
            "name",
            "code",
            "shortName",
            "cname",
            "staffId",
            "aliasName",
          ],
          clearable: true,
          allowClear: true,
          sort: {
            by: "code",
            order: "asc",
          },
        },
      },
      //signedBy, signedBy2
      {
        field: "signedBy",
        type: "RemoteSelect",
        label: "Handler 1",
        props: {
          apiEntity: "user",
          valueField: "_id",
          select: "name code shortName cname staffId aliasName",
          labelField: "name",
          labelRender: (data) => {
            // if (!data) return null;
            try {
              let text = "";
              if (data?.staffId) text += `[${data?.staffId}] `;
              if (data?.name) text += `${data?.name}`;
              if (data?.aliasName) text += ` (${data?.aliasName})`;
              return text;
            } catch (e) {
              console.error(e);
              return "";
            }
          },
        },
      },
      {
        field: "signedBy2",
        type: "RemoteSelect",
        label: "Handler 2",
        props: {
          apiEntity: "user",
          valueField: "_id",
          select: "name code shortName cname staffId aliasName",
          labelField: "name",
          labelRender: (data) => {
            // if (!data) return null;
            try {
              let text = "";
              if (data?.staffId) text += `[${data?.staffId}] `;
              if (data?.name) text += `${data?.name}`;
              if (data?.aliasName) text += ` (${data?.aliasName})`;
              return text;
            } catch (e) {
              console.error(e);
              return "";
            }
          },
        },
      },
    ],
  };
  const editFormSchema = {
    display: {
      mode: ENUM_FORM_DISPLAY.LINK,
    },
    title: "Renewal",
    titleField: "code",
    apiEntity,
    initialValues,
    layout: {
      containers: [
        {
          key: "main-g",
          parent: null,
          type: ENUM_FORM_LAYOUT_CONTAINER.GRID,
          props: {
            gutter: "xl",
            columns: 24,
          },
          cols: [
            {
              key: "main-g1",
              props: {
                span: 6,
              },
            },
            {
              key: "main-g2",
              props: {
                span: 18,
              },
            },
          ],
        },

        {
          key: "main-tab",
          parent: "main-g2",
          type: ENUM_FORM_LAYOUT_CONTAINER.TABS,
          props: {
            variant: "default", //default | pills | outline
            defaultValue: "Details",
          },
          tab: [
            {
              key: "tab-details",
              label: "Details",
              //icon: IconSettings,
            },
            {
              key: "tab-related-orders",
              label: "Related Orders",
            },
            {
              key: "tab-internalRemark",
              label: "Internal Remark",
            },
            {
              key: "tab-insured",
              label: "Insured",
              //icon: IconSettings,
            },
            {
              key: "tab-files",
              label: "Files",
              //icon: IconSettings,
            },
            {
              key: "tab-logs",
              label: "Logs",
              // icon: IconSettings
            },
          ],
        },

        {
          key: "section-summary",
          parent: "tab-details",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Details",
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },

        {
          key: "section-related-debit-notes",
          parent: "tab-related-orders",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Related Debit Notes",
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },

        {
          key: "section-previous",
          parent: "tab-details",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Previous Records",
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },
        {
          key: "section-receivedRenewal",
          parent: "tab-details",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Received Record From Insurer",
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },

        {
          key: "section-rejection",
          parent: "tab-details",
          visibleOnly: (data) => data.status === "TERMINATE",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Rejection",
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },
        {
          key: "section-delivery",
          parent: "tab-details",
          visibleOnly: (data) => data.delivery?.date,
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Delivery",
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },

        {
          key: "detail-g",
          parent: "section-summary",
          type: ENUM_FORM_LAYOUT_CONTAINER.GRID,
          props: {
            gutter: "xl",
            columns: 24,
          },
          cols: [
            {
              key: "detail-g1",
              props: {
                span: 12,
              },
            },
            {
              key: "detail-g2",
              props: {
                span: 12,
              },
            },
          ],
        },

        // {
        //   key: "section-address",
        //   parent: "tab-details",
        //   type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        //   props: {
        //     title: "Order Address",
        //     titleOrder: 5,
        //     // description: "Please assign the corresponding consultant",
        //     withBorder: false,
        //     minHeight: 0,
        //     mt: 20,
        //     mb: 20,
        //   },
        // },

        {
          key: "section-insured",
          parent: "tab-insured",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Insured Details",
            titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            minHeight: 0,

            mt: 20,
            mb: 20,
          },
        },

        {
          key: "section-quo-files",
          parent: "tab-files",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "File List",
            titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            minHeight: "0px",
            mt: 20,
            mb: 20,
          },
        },

        {
          key: "section-files",
          parent: "tab-files",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Files",
            titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            minHeight: "0px",
            mt: 20,
            mb: 20,
          },
        },

        {
          key: "tab-content",
          parent: "tab-details",
          type: ENUM_FORM_LAYOUT_CONTAINER.TABS,
          props: {
            variant: "default", //default | pills | outline
            defaultValue: "Descriptions",
          },
          tab: [
            {
              key: "tab-descriptions",
              label: "Descriptions",
              //icon: IconSettings,
            },
            {
              key: "tab-particulars",
              label: "Particulars",
              //icon: IconSettings,
            },
            {
              key: "tab-terms",
              label: "Terms",
              //icon: IconSettings,
            },
          ],
        },
        {
          key: "tab-payment",
          parent: "tab-details",
          type: ENUM_FORM_LAYOUT_CONTAINER.TABS,
          props: {
            variant: "default", //default | pills | outline
            defaultValue: "Charge Items",
          },
          tab: [
            {
              key: "tab-chargeItem",
              label: "Charge Items",
              //icon: IconSettings,
            },
            {
              key: "tab-costItem",
              label: "Cost Items",
              //icon: IconSettings,
            },
          ],
        },
        {
          key: "section-description",
          parent: "tab-descriptions",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            // title: "Description",
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },

        {
          key: "section-particulars",
          parent: "tab-particulars",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },

        {
          key: "section-term",
          parent: "tab-terms",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },
        {
          key: "section-charges",
          parent: "tab-chargeItem",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            // title: "Charge Items",
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },
        {
          key: "section-cost",
          parent: "tab-costItem",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            // title: "Cost Items",
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },
        // {
        // 	key: "section-payments",
        // 	parent: "tab-details",
        // 	type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        // 	props: {
        // 		title: "Payments",
        // 		withBorder: false,
        // 		mt: 0,
        // 		mb: "md",
        // 	},
        // },
        {
          key: "section-log",
          parent: "tab-logs",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            // title: "Logs",
            titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            mt: 20,
            mb: 20,
          },
        },
        {
          key: "section-action-list",
          parent: "main-g1",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Action List",
            // titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            minHeight: "0px",
            mt: 0,
            mb: 20,
          },
        },
        {
          key: "section-internalRemark",
          parent: "tab-internalRemark",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Internal Remark",
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },
      ],
      fields: [
        {
          name: "code",
          component: UniqueTextInput,
          parent: "detail-g1",
          props: {
            required: true,
            uniqueEntity: "renewal",
            errorMessage: "Renewal is already exist.",
            label: "Renewal Number (Auto)",
            placeholder: "QUO23100011",
            mt: 0,
          },
        },
        {
          name: "status",
          component: DummyWidget,
          parent: "detail-g2",
          props: {
            dummyRender: (formValues) => (
              <Group noWrap align="center" spacing={"lg"}>
                <Input.Wrapper label={t("Status")} mb="md">
                  <div>{cellRender.Status(formValues.status)} </div>
                </Input.Wrapper>
              </Group>
            ),
          },
        },

        {
          name: "date",
          component: DatePicker,
          parent: "detail-g2",
          type: "datePicker",
          props: {
            required: true,
            label: "Date",
            zIndex: 1000,
            placeholder: "Pick Date",
            allowFreeInput: true,
          },
        },
        {
          name: "receivedRenewal.date",
          component: DatePicker,
          parent: "section-receivedRenewal",
          type: "datePicker",
          props: {
            label: "Received Date",
          },
        },
        {
          name: "receivedRenewal.remark",
          component: Textarea,
          parent: "section-receivedRenewal",
          props: {
            label: "Remark",
          },
        },

        {
          name: "provider",
          component: RemoteSelect2,
          parent: "detail-g2",
          props: {
            apiEntity: "provider",

            required: true,
            label: "Insurer",
            placeholder: "Select Insurer",
            valueField: "_id",
            labelField: "name",
            labelRender: (data) =>
              `[ ${data.code} ] ${data.name} ${data.cname || ""}`,
            multiple: false,
            pageSize: 500,
            searchFields: ["name", "cname"],
            sort: {
              by: "name",
              order: "asc",
            },
          },
        },

        {
          name: "productType",
          component: RemoteSelect2,
          parent: "detail-g2",
          props: {
            apiEntity: "productType",
            required: true,

            label: "Class",
            placeholder: "Select Class",
            valueField: "_id",
            labelField: "name",
            labelRender: (data) =>
              `[ ${data.code} ] ${data.name} ${data.cname || ""}`,
            multiple: false,
            pageSize: 500,
            searchFields: ["name", "cname"],
            sort: {
              by: "name",
              order: "asc",
            },
          },
        },

        // {
        //   name: "product",
        //   component: RemoteSelect2,
        //   parent: "detail-g1",
        //   props: {
        //     apiEntity: "product",
        //     required: true,
        //     label: "Product",
        //     placeholder: "Select Product",
        //     valueField: "_id",
        //     labelField: "name",
        //     labelRender: (data) => `${data.name} ${data.cname}`,
        //     multiple: false,
        //     pageSize: 500,
        //     mt: 0,
        //     preQuery: {
        //       category: "62f2126bfecf22b7db4ef51c",
        //     },
        //     searchFields: ["name", "cname"],
        //     sort: {
        //       by: "name",
        //       order: "asc",
        //     },
        //   },
        // },

        {
          name: "client",
          component: remoteSelect2,
          parent: "detail-g1",
          props: {
            apiEntity: "client",
            required: true,
            label: "Applicant",
            placeholder: "Search Client By Name / HKID/ BR ",
            valueField: "_id",
            labelField: "name",
            allowClear: true,
            labelRender: (data) =>
              `[ ${data.code ?? " -- "} ] ${data.name} ${data?.cname ?? ""} ${
                data.id ? `(${data.id})` : ""
              } `,
            //   labelRender: (data) => `${data.cname}`,
            multiple: false,
            // preQuery: { $and: [ {isConsultant : true}, {isActive: true} ] },
            // preQuery:  {isConsultant : true} ,
            searchFields: ["name", "id", "cname"],
            clearable: true,
            onDataChange: (value, form) => {
              // console.log("Client Change", value);
              //Set Consultant
              if (!value || _.isEmpty(value.consultants))
                form.setFieldValue("consultants", []);
              else {
                form.setFieldValue(
                  "consultants",
                  value.consultants.map((c) => c._id),
                );
              }
            },
            sort: {
              by: "name",
              order: "asc",
            },
          },
        },

        {
          name: "period.start",
          component: DatePicker,
          parent: "detail-g1",
          type: "datePicker",
          props: {
            label: "Period From",
            zIndex: 1000,
            placeholder: "Pick Date",
            allowFreeInput: true,
          },
        },

        {
          name: "period.end",
          component: DatePicker,
          parent: "detail-g1",
          type: "datePicker",
          props: {
            label: "Period To",
            zIndex: 1000,
            placeholder: "Pick Date",
            allowFreeInput: true,
          },
        },
        {
          name: "insurerNoticeDate",
          component: DatePicker,
          parent: "detail-g1",
          type: "datePicker",
          props: {
            label: "Insurer Notice Date",
            zIndex: 1000,
            placeholder: "Pick Date",
            allowFreeInput: true,
          },
        },

        {
          name: "renewalCount",
          component: NumberInput,
          parent: "detail-g2",
          props: {
            label: "Renewal Count",
            placeholder: "1",
            defaultValue: 1,
          },
        },

        {
          name: "debitNote",
          component: DummyWidget,
          parent: "detail-g2",
          props: {
            dummyRender: (formValues) => {
              const debitNote = formValues?.debitNote;
              if (!debitNote) return null;
              const debitNoteId = debitNote?._id || debitNote?.id;
              const code = debitNote?.code ?? "--";
              // You may want to update the link path if needed
              const link = `/gi/debitNote?id=${debitNoteId}&mode=edit`;
              return (
                <>
                  <Input.Wrapper label={t("Debit Note")}></Input.Wrapper>
                  <a
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none" }}
                  >
                    {code}
                  </a>
                </>
              );
            },
          },
        },

        {
          name: "signedBy",
          component: RemoteSelect2,
          parent: "detail-g1",
          props: {
            apiEntity: "user",
            required: false,
            label: "Handler 1",

            placeholder: "Please select handler",
            valueField: "_id",
            labelField: "name",
            labelRender: (data) =>
              `[${data?.staffId ?? " -- "}] ${data?.name} ${
                data?.aliasName ?? ""
              }  ${data?.cname ?? ""} `,
            multiple: false,
            preQuery: {
              $and: [{ isConsultant: true }, { status: "ACTIVE" }],
            },
            pageSize: 1000,

            searchFields: [
              "aliasName",
              "name",
              "staffId",
              "cname",
              "email",
              "phone",
            ],
            sort: {
              by: "name",
              order: "asc",
            },
          },
        },

        {
          name: "signedBy2",
          component: RemoteSelect2,
          parent: "detail-g2",
          props: {
            apiEntity: "user",
            required: false,
            label: "Handler 2",
            placeholder: "Please select handler 2",
            valueField: "_id",
            labelField: "name",
            labelRender: (data) =>
              `[${data?.staffId ?? " -- "}] ${data?.name} ${
                data?.aliasName ?? ""
              }  ${data?.cname ?? ""} `,
            multiple: false,
            preQuery: {
              $and: [{ isConsultant: true }, { status: "ACTIVE" }],
            },
            pageSize: 1000,
            mt: 0,
            searchFields: [
              "aliasName",
              "name",
              "staffId",
              "cname",
              "email",
              "phone",
            ],
            sort: {
              by: "name",
              order: "asc",
            },
          },
        },
        {
          name: "consultants",
          component: RemoteSelect2,
          parent: "detail-g1",
          props: {
            apiEntity: "user",
            required: true,
            label: "Consultants",
            placeholder: "Please select consultant(s)",
            valueField: "_id",
            labelField: "name",
            labelRender: (data) =>
              `[${data.staffId ?? " -- "}] ${data.name} ${
                data?.aliasName ?? ""
              }  ${data?.cname ?? ""} `,
            multiple: true,
            preQuery: {
              $and: [{ isConsultant: true }, { status: "ACTIVE" }],
            },
            pageSize: 2000,
            searchFields: [
              "aliasName",
              "name",
              "staffId",
              "cname",
              "email",
              "phone",
            ],
            sort: {
              by: "name",
              order: "asc",
            },
          },
        },
        {
          name: "previousOrderRecords",
          component: RenewalPreviousRecord,
          parent: "section-previous",
          props: {},
        },
        {
          name: "relatedDebitNotesSection",
          component: DebitNoteRelatedDebitNotesSection,
          parent: "section-related-debit-notes",
          props: {
            source: "renewal",
          },
        },

        {
          name: "descriptions",
          component: QuotationDescriptions,
          parent: "section-description",
          props: {
            // required: true,
            label: "Description",
            placeholder: "Please enter description",
            enablePageBreak: true,
          },
        },
        {
          name: "particulars",
          component: DNParticularList,
          parent: "section-particulars",
          props: {
            label: "Particulars Fields",
          },
        },
        {
          name: "insured",
          component: OrderInsuredList,
          parent: "section-insured",
          props: {},
        },

        {
          name: "terms",
          component: QuotationTerms,
          parent: "section-term",
          props: {
            required: true,
          },
        },

        {
          name: "actions",
          component: RenewalActionList,
          parent: "section-action-list",
          props: {},
        },

        {
          name: "delivery.date",
          component: DatePicker,
          parent: "section-delivery",
          type: "datePicker",
          props: {
            required: true,
            label: "Delivery Date",
            zIndex: 1000,
            placeholder: "Pick Date",
            allowFreeInput: true,
          },
        },

        {
          name: "delivery.remark",
          component: Textarea,
          parent: "section-delivery",
          props: {
            label: "Remark",
          },
        },
        {
          name: "rejection.date",
          component: DatePicker,
          parent: "section-rejection",
          type: "datePicker",
          props: {
            required: true,
            label: "Rejection Date",
            zIndex: 1000,
            placeholder: "Pick Date",
            allowFreeInput: true,
          },
        },
        {
          name: "rejection.reason",
          component: Select,
          parent: "section-rejection",
          props: {
            data: DATA_RENEWAL_REJECTION_REASON,
            label: "Reason",
          },
        },
        {
          name: "rejection.remark",
          component: Textarea,
          parent: "section-rejection",
          props: {
            label: "Remark",
          },
        },

        //old
        // {
        //   name: "consultants",
        //   component: OrderConsultantList,
        //   parent: "section-consultant",
        //   props: {},
        // },

        // {
        //   name: "summary",
        //   component: QuotationSummary,
        //   parent: "section-summary",
        //   props: {},
        // },

        // {
        //   name: "insured",
        //   component: OrderInsuredList,
        //   parent: "section-insured",
        //   props: {},
        // },

        // {
        //   name: "descriptions",
        //   component: QuotationDescription,
        //   parent: "section-description",
        //   props: {
        //     required: true,
        //   },
        // },

        {
          name: "costItems",
          component: DebitNoteCostItems,
          parent: "section-cost",
          props: {
            required: true,
            allowGetRate: true,
          },
        },
        {
          name: "chargeItems",
          component: DebitNoteChargeItems,
          parent: "section-charges",
          props: {
            required: true,
          },
        },

        {
          name: "summary",
          component: QuotationChargeSummary,
          parent: "section-charges",
          props: {
            required: true,
          },
        },
        {
          name: "files",
          component: FileList,
          parent: "section-files",
          props: {},
        },

        {
          name: "fileList",
          component: QuoFileList,
          parent: "section-quo-files",
          props: {
            // title: "Please upload related files.",
          },
        },

        {
          name: "log",
          component: ActivityLog,
          parent: "section-log",
          props: {},
        },
        {
          name: "internalRemark",
          component: RichTextEditor,
          parent: "section-internalRemark",
          props: {},
        },
      ],
    },
  };

  const formSchema = {
    add: editFormSchema,
    edit: editFormSchema,
  };
  return (
    <>
      {/* <ReactJson src={preQuery} style={{ backgroundColor: "white" }} /> */}

      {/* GI Pending Renewals Section - Only for CONSULTANT role */}
      {role === "CONSULTANT" && !openRenewalFromLink && (
        <Page title={"GI Renewal"}>
          {/* GI Pending Renewals Table Section */}
          <FormSectionCard title={"GI Pending Renewals"} mb="xl">
            <Group position="apart" align="flex-start" mb="xl">
              <Group spacing="xs" align="center">
                <Text size="sm" color="dimmed">
                  Expiry Date:
                </Text>
                <OrderFilter
                  handlePeriodChange={(period) => {
                    setDateFilter({
                      periodOption: period.periodOption || "M",
                      startDate: period.startDate,
                      endDate: period.endDate,
                    });
                  }}
                  forward={true}
                  numPeriods={13}
                  pastPeriods={3}
                  by="M"
                  position="right"
                  showPeriodOptionsSelector={true}
                  hideDateTypeSelector={true}
                />
              </Group>
              <Group spacing="xs" align="center">
                <Button
                  loading={downloadingRenewals}
                  onClick={downloadPendingRenewals}
                  variant="light"
                  color="blue"
                  size="xs"
                  leftIcon={<IconDownload size={14} />}
                >
                  {t("Download Report")}
                </Button>
              </Group>
            </Group>

            {/* Filter Tabs */}
            <SegmentedControl
              value={activeTab}
              onChange={setActiveTab}
              data={consultantPendingTabSegmentedData}
              mb="xs"
              mt="md"
              fullWidth
              styles={{
                label: { fontVariantNumeric: "tabular-nums" },
              }}
            />
            <Text size="xs" color="dimmed" mb="md" ml={5}>
              {pendingListTotal || pendingRenewals.length}{" "}
              {t(
                (pendingListTotal || pendingRenewals.length) === 1
                  ? "record"
                  : "records",
              )}
            </Text>

            <TextInput
              placeholder={t("Search")}
              icon={<IconSearch size={14} stroke={1.5} />}
              value={pendingListSearchInput}
              onChange={(e) => setPendingListSearchInput(e.currentTarget.value)}
              rightSection={
                pendingListSearchInput ? (
                  <UnstyledButton
                    type="button"
                    onClick={() => setPendingListSearchInput("")}
                    aria-label={t("Clear search")}
                  >
                    <IconX size={14} stroke={1.5} />
                  </UnstyledButton>
                ) : null
              }
              mb="md"
              style={{ width: "100%" }}
            />

            <ScrollArea type="auto">
              <Table
                sx={{
                  "& thead th, & tbody td": { verticalAlign: "top" },
                }}
              >
                <thead>
                  <tr>
                    <th>
                      <Text size="xs">Debit Note</Text>
                    </th>
                    <th>
                      <Text size="xs">RN Code</Text>
                    </th>
                    <th>
                      <Text size="xs">Received</Text>
                    </th>
                    <th>
                      <Text size="xs">Expiry</Text>
                    </th>
                    <th>
                      <Text size="xs">Product</Text>
                    </th>
                    <th>
                      <Text size="xs">Client</Text>
                    </th>
                    <th style={{ minWidth: 200 }}>
                      <Text size="xs">Consultants</Text>
                    </th>
                    <th>
                      <Text size="xs">Action</Text>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {pendingRenewals.map((dn) => (
                    <tr key={dn._id}>
                      {/* Debit Note Column */}
                      <td>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "2px",
                          }}
                        >
                          <Group noWrap spacing={1}>
                            <Badge
                              color={
                                dn.type === "NEW"
                                  ? "green"
                                  : dn.type === "RENEW"
                                    ? "blue"
                                    : "gray"
                              }
                              size="xs"
                              radius={0}
                            >
                              {dn.type === "NEW"
                                ? "N"
                                : dn.type === "RENEW"
                                  ? "R"
                                  : "N"}
                            </Badge>
                            <Badge
                              color={
                                dn.status === "CONFIRMED" ||
                                dn.status === "SETTLED"
                                  ? "blue"
                                  : "yellow"
                              }
                              size="xs"
                              radius={0}
                            >
                              {dn.status}
                            </Badge>
                          </Group>
                          {getDebitNoteLink() ? (
                            <Text
                              size="xs"
                              weight={500}
                              style={{
                                lineHeight: 1.2,
                                color: "#c1c2c5",
                                cursor: "pointer",
                              }}
                              onClick={() => openDebitNoteEdit(dn._id, dn.code)}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.color = "#228be6";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.color = "#c1c2c5";
                              }}
                            >
                              {dn.code}
                            </Text>
                          ) : (
                            <Text size="xs" style={{ lineHeight: 1.2 }}>
                              {dn.code}
                            </Text>
                          )}
                          <Text
                            size="xs"
                            color="dimmed"
                            style={{ lineHeight: 1.2 }}
                          >
                            {dn.date
                              ? moment(dn.date).format("YYYY-MM-DD")
                              : ""}
                          </Text>
                        </div>
                      </td>

                      {/* Renewal Code Column — confirmed RN: new DN code in green (same target as green DN action) */}
                      <td>
                        {dn.renewal ? (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "2px",
                            }}
                          >
                            <Group noWrap spacing={2}>
                              <Badge
                                size="xs"
                                radius={0}
                                color={dn.renewal.fromSystem ? "green" : "blue"}
                              >
                                {dn.renewal.fromSystem ? "SYSTEM" : "MANUAL"}
                              </Badge>
                              <Badge
                                size="xs"
                                radius={0}
                                color={
                                  dn.renewal.status === "CONFIRM"
                                    ? "green"
                                    : dn.renewal.status === "PENDING"
                                      ? "yellow"
                                      : dn.renewal.status === "WAIT"
                                        ? "blue"
                                        : "gray"
                                }
                              >
                                {dn.renewal.status}
                              </Badge>
                            </Group>
                            {dn.renewal.status === "CONFIRM" &&
                            getRenewalNewDebitNoteId(dn) &&
                            getDebitNoteLink() ? (
                              <>
                                {getRenewalLink() ? (
                                  <Text
                                    size="xs"
                                    weight={500}
                                    style={{
                                      lineHeight: 1.2,
                                      color: "#868e96",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      openRenewalEdit(dn.renewal._id, dn.renewal.code)
                                    }
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.color = "#228be6";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.color = "#868e96";
                                    }}
                                  >
                                    {dn.renewal.code}
                                  </Text>
                                ) : (
                                  <Text
                                    size="xs"
                                    weight={500}
                                    color="dimmed"
                                    style={{ lineHeight: 1.2 }}
                                  >
                                    {dn.renewal.code}
                                  </Text>
                                )}
                              </>
                            ) : getRenewalLink() ? (
                              <Text
                                size="xs"
                                weight={500}
                                style={{
                                  lineHeight: 1.2,
                                  color: "#c1c2c5",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  openRenewalEdit(dn.renewal._id, dn.renewal.code)
                                }
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.color = "#228be6";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.color = "#c1c2c5";
                                }}
                              >
                                {dn.renewal.code}
                              </Text>
                            ) : (
                              <Text
                                size="xs"
                                weight={500}
                                style={{ lineHeight: 1.2 }}
                              >
                                {dn.renewal.code}
                              </Text>
                            )}
                            {dn.renewal.date && (
                              <Text
                                size="xs"
                                color="dimmed"
                                style={{ lineHeight: 1.2 }}
                              >
                                {moment(dn.renewal.date).format("YYYY-MM-DD")}
                              </Text>
                            )}
                            {dn.renewal.status === "CONFIRM" &&
                              getRenewalNewDebitNoteId(dn) &&
                              getDebitNoteLink() && (
                                <Text
                                  size="xs"
                                  weight={600}
                                  color="green"
                                  style={{
                                    lineHeight: 1.2,
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    openDebitNoteEdit(
                                      getRenewalNewDebitNoteId(dn),
                                      dn.renewal.debitNote?.code,
                                    )
                                  }
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.textDecoration =
                                      "underline";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.textDecoration =
                                      "none";
                                  }}
                                >
                                  {dn.renewal.debitNote?.code}
                                </Text>
                              )}
                          </div>
                        ) : (
                          <Text size="xs" color="dimmed">
                            -
                          </Text>
                        )}
                      </td>

                      {/* RN Received Column */}
                      <td>
                        {dn.renewal ? (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "2px",
                            }}
                          >
                            <Badge
                              size="xs"
                              radius={0}
                              color={
                                dn.renewal.receivedRenewal?.date
                                  ? "blue"
                                  : "orange"
                              }
                            >
                              {dn.renewal.receivedRenewal?.date
                                ? "Received"
                                : "Not Received"}
                            </Badge>
                            {dn.renewal.receivedRenewal?.date && (
                              <Text
                                size="xs"
                                color="dimmed"
                                style={{
                                  lineHeight: 1.2,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {moment(dn.renewal.receivedRenewal.date).format(
                                  "YYYY-MM-DD",
                                )}
                              </Text>
                            )}
                          </div>
                        ) : (
                          <Text size="xs" color="dimmed">
                            -
                          </Text>
                        )}
                      </td>

                      {/* Expiry Column */}
                      <td>
                        {dn.period?.end && (
                          <Text size="xs">
                            {moment(dn.period.end).format("YYYY/MM/DD")}
                          </Text>
                        )}
                      </td>

                      {/* Product Column — same as debit note / main renewal list (ProductInfo + key particulars) */}
                      <td>
                        {dn.product ? (
                          cellRender.ProductInfo(
                            dn.product,
                            "xs",
                            dn.particulars,
                            { hideAvatar: true },
                          )
                        ) : dn.productType || dn.provider ? (
                          cellRender.ProductInfo2(
                            {
                              productType: dn.productType,
                              provider: dn.provider,
                              particulars: dn.particulars || [],
                            },
                            "xs",
                            { hideAvatar: true },
                          )
                        ) : (
                          <Text size="xs" color="dimmed">
                            -
                          </Text>
                        )}
                      </td>

                      {/* Client Column — same layout as management /m/gi/renewal */}
                      <td>
                        {dn.client && (
                          <div>
                            <Text
                              size="xs"
                              weight={500}
                              style={{
                                lineHeight: 1.2,
                                color: "#c1c2c5",
                                cursor: getClientLink() ? "pointer" : "default",
                              }}
                              onClick={() => openClientEdit(dn.client._id, dn.client)}
                              onMouseEnter={(e) => {
                                if (getClientLink())
                                  e.currentTarget.style.color = "#228be6";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.color = "#c1c2c5";
                              }}
                            >
                              {dn.client.name}
                            </Text>
                            <Text
                              size="xs"
                              color="dimmed"
                              style={{ lineHeight: 1.2 }}
                            >
                              {dn.client.cname}
                            </Text>
                            <Text
                              size="xs"
                              color="dimmed"
                              style={{ lineHeight: 1.2 }}
                            >
                              {dn.client.code}
                            </Text>

                            {dn.policyNumber && (
                              <Text
                                size="xs"
                                color="dimmed"
                                style={{ lineHeight: 1.2 }}
                              >
                                {dn.policyNumber}
                              </Text>
                            )}
                          </div>
                        )}
                      </td>

                      {/* Consultants Column */}
                      <td>
                        {dn.consultants && dn.consultants.length > 0 ? (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "2px",
                            }}
                          >
                            {dn.consultants.map((consultant, idx) => (
                              <Text
                                key={idx}
                                size="xs"
                                style={{
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                  lineHeight: 1.35,
                                }}
                              >
                                {consultant.name}
                                {consultant.staffId && (
                                  <span style={{ color: "#909296" }}>
                                    {" "}
                                    ({consultant.staffId})
                                  </span>
                                )}
                              </Text>
                            ))}
                          </div>
                        ) : (
                          <Text size="xs" color="dimmed">
                            -
                          </Text>
                        )}
                      </td>

                      {/* Action: green DN opens post-confirm RN debit note */}
                      <td>
                        <Group spacing="xs" noWrap>
                          {!dn.renewal && (
                            <Button
                              type="button"
                              size="xs"
                              variant="light"
                              color="orange"
                              loading={
                                manualRenewalLoadingId === String(dn._id)
                              }
                              onClick={() => {
                                if (
                                  !window.confirm(
                                    t("Create a renewal for this debit note?"),
                                  )
                                ) {
                                  return;
                                }
                                void handleManualRenewalFromDebitNote(dn);
                              }}
                            >
                              {t("Manual Renewal")}
                            </Button>
                          )}
                          {dn.renewal && getRenewalLink() && (
                            <Button
                              type="button"
                              size="xs"
                              variant="light"
                              color="blue"
                              onClick={() =>
                                openRenewalEdit(
                                  dn.renewal._id,
                                  dn.renewal.code,
                                )
                              }
                            >
                              RN
                            </Button>
                          )}
                          {dn.renewal?.status === "CONFIRM" &&
                            getRenewalNewDebitNoteId(dn) &&
                            getDebitNoteLink() && (
                              <Button
                                type="button"
                                size="xs"
                                variant="light"
                                color="green"
                                onClick={() =>
                                  openDebitNoteEdit(
                                    getRenewalNewDebitNoteId(dn),
                                    dn.renewal.debitNote?.code,
                                  )
                                }
                              >
                                DN
                              </Button>
                            )}
                        </Group>
                      </td>
                    </tr>
                  ))}
                  {pendingRenewals.length === 0 && (
                    <tr>
                      <td colSpan={8}>
                        <Text size="xs" color="dimmed" align="center">
                          No records found for this filter
                        </Text>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </ScrollArea>
            {/* Pagination Bar */}
            <Group position="right" mt="md">
              <PaginationBar
                pageSize={pendingListPageSize}
                onPageSizeChange={(size) => {
                  setPendingListPageSize(Number(size));
                  setPendingListPage(1);
                }}
                pagination={{
                  page: pendingListPage,
                  totalPage: pendingListTotalPage,
                  total: pendingListTotal,
                }}
                onPageChange={setPendingListPage}
                currentPage={pendingListPage}
              />
            </Group>
          </FormSectionCard>
        </Page>
      )}

      {/* GI Pending Renewals Section - Management /m/gi/renewal (all consultants) */}
      {isManagementGiRenewal && !openRenewalFromLink && (
        <Page title={"GI Renewal Management"}>
          <FormSectionCard
            title={"GI Pending Renewals - All Consultants"}
            mb="xl"
          >
            <Group position="apart" align="flex-start" mb="xl">
              <Group spacing="xs" align="center">
                <Text size="sm" color="dimmed">
                  Period End:
                </Text>
                <OrderFilter
                  handlePeriodChange={(period) => {
                    setDateFilter({
                      periodOption: period.periodOption || "M",
                      startDate: period.startDate,
                      endDate: period.endDate,
                    });
                  }}
                  forward={true}
                  numPeriods={13}
                  pastPeriods={3}
                  by="M"
                  position="right"
                  showPeriodOptionsSelector={true}
                  hideDateTypeSelector={true}
                />
              </Group>
              <Group spacing="xs" align="center">
                <Button
                  loading={managementDownloadingRenewals}
                  onClick={downloadManagementPendingRenewalReport}
                  variant="light"
                  color="blue"
                  size="xs"
                  leftIcon={<IconDownload size={14} />}
                >
                  {t("Download Report")}
                </Button>
              </Group>
            </Group>

            {/* Filter Tabs */}
            <SegmentedControl
              value={managementActiveTab}
              onChange={setManagementActiveTab}
              data={managementPendingTabSegmentedData}
              mb="xl"
              mt="md"
              fullWidth
              styles={{
                label: { fontVariantNumeric: "tabular-nums" },
              }}
            />

            <TextInput
              placeholder={t("Search")}
              icon={<IconSearch size={14} stroke={1.5} />}
              value={pendingListSearchInput}
              onChange={(e) => setPendingListSearchInput(e.currentTarget.value)}
              rightSection={
                pendingListSearchInput ? (
                  <UnstyledButton
                    type="button"
                    onClick={() => setPendingListSearchInput("")}
                    aria-label={t("Clear search")}
                  >
                    <IconX size={14} stroke={1.5} />
                  </UnstyledButton>
                ) : null
              }
              mb="md"
              style={{ width: "100%" }}
            />

            <ScrollArea type="auto" mb="xl">
              <Table
                sx={{
                  "& thead th, & tbody td": { verticalAlign: "top" },
                }}
              >
                <thead>
                  <tr>
                    <th>
                      <Text size="xs">Debit Note</Text>
                    </th>
                    <th>
                      <Text size="xs">RN Code</Text>
                    </th>
                    <th>
                      <Text size="xs">Received</Text>
                    </th>
                    <th>
                      <Text size="xs">Expiry</Text>
                    </th>
                    <th>
                      <Text size="xs">Product</Text>
                    </th>
                    <th>
                      <Text size="xs">Client</Text>
                    </th>
                    <th style={{ minWidth: 200 }}>
                      <Text size="xs">Consultants</Text>
                    </th>
                    <th>
                      <Text size="xs">Action</Text>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {managementPendingRenewals.map((dn) => (
                    <tr key={dn._id}>
                      {/* Debit Note Column */}
                      <td>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "2px",
                          }}
                        >
                          <Group noWrap spacing={1}>
                            <Badge
                              color={
                                dn.type === "NEW"
                                  ? "green"
                                  : dn.type === "RENEW"
                                    ? "blue"
                                    : "gray"
                              }
                              size="xs"
                              radius={0}
                            >
                              {dn.type === "NEW"
                                ? "N"
                                : dn.type === "RENEW"
                                  ? "R"
                                  : "N"}
                            </Badge>
                            <Badge
                              color={
                                dn.status === "CONFIRMED" ||
                                dn.status === "SETTLED"
                                  ? "blue"
                                  : "yellow"
                              }
                              size="xs"
                              radius={0}
                            >
                              {dn.status}
                            </Badge>
                          </Group>
                          {getDebitNoteLink() ? (
                            <Text
                              size="xs"
                              weight={500}
                              style={{
                                lineHeight: 1.2,
                                color: "#c1c2c5",
                                cursor: "pointer",
                              }}
                              onClick={() => openDebitNoteEdit(dn._id, dn.code)}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.color = "#228be6";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.color = "#c1c2c5";
                              }}
                            >
                              {dn.code}
                            </Text>
                          ) : (
                            <Text
                              size="xs"
                              weight={500}
                              style={{ lineHeight: 1.2 }}
                            >
                              {dn.code}
                            </Text>
                          )}
                          {dn.date && (
                            <Text
                              size="xs"
                              color="dimmed"
                              style={{ lineHeight: 1.2 }}
                            >
                              {moment(dn.date).format("YYYY-MM-DD")}
                            </Text>
                          )}
                        </div>
                      </td>

                      {/* Renewal Code Column — confirmed RN: new DN code in green */}
                      <td>
                        {dn.renewal ? (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "2px",
                            }}
                          >
                            <Group noWrap spacing={2}>
                              <Badge
                                size="xs"
                                radius={0}
                                color={dn.renewal.fromSystem ? "green" : "blue"}
                              >
                                {dn.renewal.fromSystem ? "SYSTEM" : "MANUAL"}
                              </Badge>
                              <Badge
                                size="xs"
                                radius={0}
                                color={
                                  dn.renewal.status === "CONFIRM"
                                    ? "green"
                                    : dn.renewal.status === "PENDING"
                                      ? "yellow"
                                      : dn.renewal.status === "WAIT"
                                        ? "blue"
                                        : "gray"
                                }
                              >
                                {dn.renewal.status}
                              </Badge>
                            </Group>
                            {dn.renewal.status === "CONFIRM" &&
                            getRenewalNewDebitNoteId(dn) &&
                            getDebitNoteLink() ? (
                              <>
                                {getRenewalLink() ? (
                                  <Text
                                    size="xs"
                                    weight={500}
                                    style={{
                                      lineHeight: 1.2,
                                      color: "#868e96",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      openRenewalEdit(dn.renewal._id, dn.renewal.code)
                                    }
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.color = "#228be6";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.color = "#868e96";
                                    }}
                                  >
                                    {dn.renewal.code}
                                  </Text>
                                ) : (
                                  <Text
                                    size="xs"
                                    weight={500}
                                    color="dimmed"
                                    style={{ lineHeight: 1.2 }}
                                  >
                                    {dn.renewal.code}
                                  </Text>
                                )}
                              </>
                            ) : getRenewalLink() ? (
                              <Text
                                size="xs"
                                weight={500}
                                style={{
                                  lineHeight: 1.2,
                                  color: "#c1c2c5",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  openRenewalEdit(dn.renewal._id, dn.renewal.code)
                                }
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.color = "#228be6";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.color = "#c1c2c5";
                                }}
                              >
                                {dn.renewal.code}
                              </Text>
                            ) : (
                              <Text
                                size="xs"
                                weight={500}
                                style={{ lineHeight: 1.2 }}
                              >
                                {dn.renewal.code}
                              </Text>
                            )}
                            {dn.renewal.date && (
                              <Text
                                size="xs"
                                color="dimmed"
                                style={{ lineHeight: 1.2 }}
                              >
                                {moment(dn.renewal.date).format("YYYY-MM-DD")}
                              </Text>
                            )}
                            {dn.renewal.status === "CONFIRM" &&
                              getRenewalNewDebitNoteId(dn) &&
                              getDebitNoteLink() && (
                                <Text
                                  size="xs"
                                  weight={600}
                                  color="green"
                                  style={{
                                    lineHeight: 1.2,
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    openDebitNoteEdit(
                                      getRenewalNewDebitNoteId(dn),
                                      dn.renewal.debitNote?.code,
                                    )
                                  }
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.textDecoration =
                                      "underline";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.textDecoration =
                                      "none";
                                  }}
                                >
                                  {dn.renewal.debitNote?.code}
                                </Text>
                              )}
                          </div>
                        ) : (
                          <Text size="xs" color="dimmed">
                            -
                          </Text>
                        )}
                      </td>

                      {/* RN Received Column */}
                      <td>
                        {dn.renewal ? (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "2px",
                            }}
                          >
                            <Badge
                              size="xs"
                              radius={0}
                              color={
                                dn.renewal.receivedRenewal?.date
                                  ? "blue"
                                  : "orange"
                              }
                            >
                              {dn.renewal.receivedRenewal?.date
                                ? "Received"
                                : "Not Received"}
                            </Badge>
                            {dn.renewal.receivedRenewal?.date && (
                              <Text
                                size="xs"
                                color="dimmed"
                                style={{
                                  lineHeight: 1.2,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {moment(dn.renewal.receivedRenewal.date).format(
                                  "YYYY-MM-DD",
                                )}
                              </Text>
                            )}
                          </div>
                        ) : (
                          <Text size="xs" color="dimmed">
                            -
                          </Text>
                        )}
                      </td>

                      {/* Expiry Column */}
                      <td>
                        {dn.period?.end && (
                          <Text size="xs">
                            {moment(dn.period.end).format("YYYY/MM/DD")}
                          </Text>
                        )}
                      </td>

                      {/* Product Column — same as debit note / main renewal list (ProductInfo + key particulars) */}
                      <td>
                        {dn.product ? (
                          cellRender.ProductInfo(
                            dn.product,
                            "xs",
                            dn.particulars,
                            { hideAvatar: true },
                          )
                        ) : dn.productType || dn.provider ? (
                          cellRender.ProductInfo2(
                            {
                              productType: dn.productType,
                              provider: dn.provider,
                              particulars: dn.particulars || [],
                            },
                            "xs",
                            { hideAvatar: true },
                          )
                        ) : (
                          <Text size="xs" color="dimmed">
                            -
                          </Text>
                        )}
                      </td>

                      {/* Client Column */}
                      <td>
                        {dn.client && (
                          <div>
                            <Text
                              size="xs"
                              weight={500}
                              style={{
                                lineHeight: 1.2,
                                color: "#c1c2c5",
                                cursor: getClientLink() ? "pointer" : "default",
                              }}
                              onClick={() => openClientEdit(dn.client._id, dn.client)}
                              onMouseEnter={(e) => {
                                if (getClientLink())
                                  e.currentTarget.style.color = "#228be6";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.color = "#c1c2c5";
                              }}
                            >
                              {dn.client.name}
                            </Text>
                            <Text
                              size="xs"
                              color="dimmed"
                              style={{ lineHeight: 1.2 }}
                            >
                              {dn.client.cname}
                            </Text>
                            <Text
                              size="xs"
                              color="dimmed"
                              style={{ lineHeight: 1.2 }}
                            >
                              {dn.client.code}
                            </Text>

                            {dn.policyNumber && (
                              <Text
                                size="xs"
                                color="dimmed"
                                style={{ lineHeight: 1.2 }}
                              >
                                {dn.policyNumber}
                              </Text>
                            )}
                          </div>
                        )}
                      </td>

                      {/* Consultants Column */}
                      <td>
                        {dn.consultants && dn.consultants.length > 0 && (
                          <div>
                            {dn.consultants.map((consultant, idx) => (
                              <Text
                                key={idx}
                                size="xs"
                                style={{
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                  lineHeight: 1.35,
                                }}
                              >
                                {consultant.name}
                                {consultant.staffId && (
                                  <span style={{ color: "#868e96" }}>
                                    {" "}
                                    ({consultant.staffId})
                                  </span>
                                )}
                              </Text>
                            ))}
                          </div>
                        )}
                      </td>

                      {/* Action: green DN opens post-confirm RN debit note */}
                      <td>
                        <Group spacing="xs" noWrap>
                          {!dn.renewal && (
                            <Button
                              type="button"
                              size="xs"
                              variant="light"
                              color="orange"
                              loading={
                                manualRenewalLoadingId === String(dn._id)
                              }
                              onClick={() => {
                                if (
                                  !window.confirm(
                                    t("Create a renewal for this debit note?"),
                                  )
                                ) {
                                  return;
                                }
                                void handleManualRenewalFromDebitNote(dn);
                              }}
                            >
                              {t("Manual Renewal")}
                            </Button>
                          )}
                          {dn.renewal?._id && getRenewalLink() && (
                            <Button
                              type="button"
                              size="xs"
                              variant="light"
                              color="blue"
                              onClick={() =>
                                openRenewalEdit(
                                  dn.renewal._id,
                                  dn.renewal.code,
                                )
                              }
                            >
                              RN
                            </Button>
                          )}
                          {dn.renewal?.status === "CONFIRM" &&
                            getRenewalNewDebitNoteId(dn) &&
                            getDebitNoteLink() && (
                              <Button
                                type="button"
                                size="xs"
                                variant="light"
                                color="green"
                                onClick={() =>
                                  openDebitNoteEdit(
                                    getRenewalNewDebitNoteId(dn),
                                    dn.renewal.debitNote?.code,
                                  )
                                }
                              >
                                DN
                              </Button>
                            )}
                        </Group>
                      </td>
                    </tr>
                  ))}
                  {managementPendingRenewals.length === 0 && (
                    <tr>
                      <td colSpan={8}>
                        <Text size="xs" color="dimmed" align="center">
                          No records found for this filter
                        </Text>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </ScrollArea>
            {/* Pagination Bar for Management */}
            <Group position="right" mt="md">
              <PaginationBar
                pageSize={pendingListPageSize}
                onPageSizeChange={(size) => {
                  setPendingListPageSize(Number(size));
                  setManagementPendingListPage(1);
                }}
                pagination={{
                  page: managementPendingListPage,
                  totalPage: managementPendingListTotalPage,
                  total: managementPendingListTotal,
                }}
                onPageChange={setManagementPendingListPage}
                currentPage={managementPendingListPage}
              />
            </Group>
          </FormSectionCard>
        </Page>
      )}

      {/* PageList: full list for non-consultant / non-management; or mount when ?id=&mode=edit so linkage opens the form */}
      {showRenewalPageList && (
        <PageList
          title={"Renewal"}
          apiEntity={"renewal"}
          tableSchema={tableSchema}
          formSchema={formSchema}
          searchByTextField={false}
          initSort={{ by: "code", order: "desc" }}
          stats={{
            component: RenewalPageStats,
            props: {
              mb: 35,
              role,
              preQuery,
            },
          }}
        />
      )}
    </>
  );
};

export default Renewal;
